<div>
    <div class="d-flex align-items-center" mat-dialog-title>
        <div class="spacer title">Asfalt</div>
        <div>
            <button (click)="close()" mat-icon-button tabindex="-1"><i class="fas fa-times"></i></button>
        </div>
    </div>
</div>
<div class="dialog-content" mat-dialog-content>
    <div class="pb-3">
        <button (click)="openImportDialog()" color="primary" mat-raised-button>Importeren</button>
        <button class="ms-2" (click)="export()" color="primary" mat-raised-button>Template downloaden</button>
    </div>
    <div class="d-flex justify-content-center align-content-center">
        <h3 class="spacer">Asfaltsoorten per molen</h3>
    </div>
    <table class="table table-hover table-last-col">
        <tr>
            <th>Molen</th>
            <th>Soort</th>
            <th>Centrale Code</th>
            <th></th>
        </tr>
        @for (mill of asphaltMills; track mill) {
            @for (asphalt of mill.asphalt; track asphalt; let i = $index) {
                <tr>
                    <td>
                        {{ mill.name }}
                    </td>
                    <td>
                        {{ asphalt.asphalt?.name }}
                    </td>
                    <td>
                        {{ asphalt.code }}
                    </td>
                    <td>
                        <button
                            class="icon-button-medium"
                            (click)="deleteAsfaltMillAsphalt(asphalt)"
                            color="warn"
                            mat-icon-button>
                            <mat-icon fontSet="fas" fontIcon="fa-trash"></mat-icon>
                        </button>
                    </td>
                </tr>
            }
        }
    </table>
</div>
